module.exports = __webpack_public_path__ + "static/media/p2.6908b7f2.svg";